export default __webpack_public_path__ + "static/media/five_of_cups.535af3ec.png";